import { GET_HOW_TO_APPLY_START } from '../../types';

export const get_how_to_apply = (payload) => ({
  type: GET_HOW_TO_APPLY_START,
  payload,
});
